export const attachmentPreviewTypes = ['gif', 'svg', 'jpeg', 'jpg', 'png', 'txt', 'pdf'];
